import React, { useState } from 'react';

// Shared presentational primitives for the speech coaching report
// (used by SpeechReport and ContentReport).

// Collapsible section — keeps secondary detail (full metrics, structure,
// transcript) out of the way by default so the report leads with the coaching.
export function Collapsible({ label, children, defaultOpen = false, count }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div>
      <button
        onClick={() => setOpen(v => !v)}
        className="flex items-center gap-2.5 w-full text-left"
      >
        <span
          className="font-mono text-[10px]"
          style={{ color: 'var(--text-faint)', transform: open ? 'rotate(90deg)' : 'none', display: 'inline-block', transition: 'transform 0.15s' }}
        >
          ▶
        </span>
        <h3 className="font-mono text-[10px] font-medium uppercase tracking-[0.2em]"
            style={{ color: 'var(--text-faint)' }}>
          {label}{count != null ? ` (${count})` : ''}
        </h3>
      </button>
      {open && <div className="mt-3">{children}</div>}
    </div>
  );
}

export function formatTime(seconds) {
  if (seconds == null) return null;
  const m = Math.floor(seconds / 60);
  const s = Math.floor(seconds % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}

export function SectionHeader({ children, accent = 'var(--accent)' }) {
  return (
    <div className="flex items-center gap-2.5 mb-3">
      <div
        className="w-0.5 h-3 rounded-full flex-shrink-0"
        style={{ background: `linear-gradient(180deg, ${accent} 0%, rgba(0,0,0,0) 100%)` }}
      />
      <h3 className="font-mono text-[10px] font-medium uppercase tracking-[0.2em]"
          style={{ color: 'var(--text-faint)' }}>
        {children}
      </h3>
    </div>
  );
}

export function Verdict({ label, good, warning, children }) {
  const color = good ? '#4AC57A' : warning ? 'var(--color-warning)' : '#E05252';
  const icon = good ? '✓' : warning ? '⚠' : '✗';
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: '0.75rem' }}>
      <span className="font-mono text-xs font-bold mt-0.5" style={{ color, minWidth: '1rem' }}>{icon}</span>
      <div>
        <span className="text-sm font-semibold" style={{ color: 'var(--text-primary)' }}>{label}</span>
        {children && <p className="text-sm mt-0.5" style={{ color: 'var(--text-muted)' }}>{children}</p>}
      </div>
    </div>
  );
}
